module.exports = __webpack_public_path__ + "./img/png.afc343460267d5f02299fc36c13aa5f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/png.png
// module id = ./src/containers/Briefcase/entry/icons/png.png
// module chunks = 0